/*  ========================================================================
    # Scripts - Accordion
    ========================================================================  */

const Accordion = {
  cfg: {
    accordionEntries: document.querySelectorAll('.s-accordion__entry'),
    states: {
      openAccordion: 's-accordion__entry--active'
    }
  },

  /**
   * Handler.
   */
  handler() {
    this.cfg.accordionEntries.forEach(entry => {
      entry.firstElementChild.addEventListener('click', () => {
        entry.classList.toggle(this.cfg.states.openAccordion);
      });
    });
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.accordionEntries.length > 0) this.handler();
  }
};

export default Accordion;
